import { render, staticRenderFns } from "./repoInfoList.vue?vue&type=template&id=449ee21c&"
import script from "./repoInfoList.vue?vue&type=script&lang=js&"
export * from "./repoInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports